import { useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { toast } from 'sonner';
import { CreditCard } from 'lucide-react';

const PremiumCard = ({ isAuthenticated }) => {
  const [loading, setLoading] = useState(false);

  const handlePurchase = async () => {
    if (!isAuthenticated) {
      toast.error('Please login to purchase premium');
      return;
    }
    setLoading(true);
    try {
      const response = await api.post('/payment/premium', {
        origin_url: window.location.origin
      });
      window.location.href = response.data.url;
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create payment');
      setLoading(false);
    }
  };

  return (
    <Card className="card-surface border-[#27272A]" data-testid="premium-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2" style={{ fontFamily: 'Outfit' }}>
          <CreditCard className="w-5 h-5 text-[#D4AF37]" />Premium Access
        </CardTitle>
        <CardDescription>Unlimited topics for 24 hours</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div>
          <div className="text-4xl font-bold text-[#D4AF37] mb-2" style={{ fontFamily: 'Outfit' }}>$1<span className="text-lg text-[#A1A1AA] font-normal">/24 hours</span></div>
          <p className="text-sm text-[#A1A1AA]">Get unlimited access to AI-powered support for a full day</p>
        </div>
        <ul className="space-y-3 text-sm">
          {['Unlimited conversation topics', 'All 6 response styles available', 'Full conversation history', 'Priority support'].map(item => (
            <li key={item} className="flex items-start gap-2"><span className="text-[#10B981] mt-0.5">&#10003;</span><span className="text-[#A1A1AA]">{item}</span></li>
          ))}
        </ul>
        <Button onClick={handlePurchase} disabled={loading || !isAuthenticated} className="btn-gold w-full rounded-full py-6 text-base font-semibold" data-testid="purchase-premium-button">
          {loading ? 'Redirecting to checkout...' : 'Purchase Premium'}
        </Button>
        {!isAuthenticated && <p className="text-xs text-center text-[#A1A1AA]">Please login to purchase premium</p>}
      </CardContent>
    </Card>
  );
};

export default PremiumCard;
